import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { PhoneNumberPipe } from '../../shared/pipes/phone-number.pipe';
// import { AngularFontAwesomeModule } from 'angular-font-awesome';
// import { NgxSelectModule } from 'ngx-select-ex';
// import { SignaturePadModule } from 'angular2-signaturepad';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { DatePipe } from '@angular/common';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NewPlansComponent } from './new-plans/new-plans.component';
import { StepsComponent } from './steps/steps.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { SafeHtmlPipe } from '../../shared/pipes/safe-html.pipe';
import { PayNowComponent } from '../pay-now/pay-now.component';
// import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import {IConfig} from 'ngx-mask';
import { IframeTllaComponent } from '../iframe-tila/iframe-tila.component';
import { ConsentFormComponent } from '../consent-form/consent-form.component';
import { ToastrService } from 'ngx-toastr';
import { ToasterService } from 'src/app/services/toaster.service';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
const routes: Routes = [
];
@NgModule({
    imports: [
        // NgxMaskModule.forRoot(),
        SharedModule,
        RouterModule.forChild(routes),
        // TextMaskModule,
        // AngularFontAwesomeModule,
        // NgxSelectModule,
        // SignaturePadModule,
        BsDatepickerModule.forRoot(),
        // NgxUsefulSwiperModule,
        ModalModule.forRoot(),
        AccordionModule.forRoot(),
        // ToasterModule,
        TypeaheadModule.forRoot(),
    ],
    declarations: [
        NewPlansComponent,
        StepsComponent,
        PaymentDetailsComponent,
        PersonalDetailsComponent,
        PayNowComponent
    ],
    exports: [
        RouterModule
    ],
    providers: [
        DatePipe,
        PhoneNumberPipe,
        SafeHtmlPipe,
        ToastrService,
        ToasterService,
        {
            provide: BsDatepickerConfig,
            useValue: undefined
        }
    ]
})
export class PlanModule { }



